"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FirebaseProvider_1 = require("../../providers/FirebaseProvider");
var DeckProvider_1 = require("../../providers/DeckProvider");
function mergeDeckNote(noteData, deckNote, noteId) {
    var content = deckNote.content, rest = __rest(deckNote, ["content"]);
    var data = __assign(__assign(__assign({}, noteData), rest), { id: noteId });
    if (deckNote.contentEdited) {
        data.content = content;
    }
    return data;
}
var useFetchNote = function (noteId, userId) {
    var db = FirebaseProvider_1.useFirebase().db;
    var deck = DeckProvider_1.useDeck();
    var _a = __read(react_1.useState(true), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(react_1.useState(null), 2), note = _b[0], setNote = _b[1];
    var deckNote = deck.notes.find(function (note) { return note.id === noteId; });
    react_1.useEffect(function () {
        setLoading(true);
        setNote(null);
        var unsubscribe = db
            .collection('notes')
            .doc(noteId)
            .onSnapshot(function (doc) {
            var docData = doc.data();
            if (docData) {
                var data_1 = __assign({}, docData);
                if (deckNote) {
                    data_1 = mergeDeckNote(data_1, deckNote, noteId);
                    setNote(data_1);
                    setLoading(false);
                }
                else if (userId) {
                    db.collection('users')
                        .doc(userId)
                        .collection('decks')
                        .doc(docData.deck)
                        .get()
                        .then(function (otherDeck) {
                        var otherDeckData = otherDeck.data();
                        if (otherDeckData && otherDeckData.notes[noteId]) {
                            data_1 = mergeDeckNote(data_1, otherDeckData.notes[noteId], noteId);
                        }
                        setNote(data_1);
                        setLoading(false);
                    });
                }
            }
        });
        return function () { return unsubscribe(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [loading, note];
};
exports.default = useFetchNote;
//# sourceMappingURL=useFetchNote.js.map